/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  APP_KEY: '1999069888890608',
  BACKEND_URL: 'https://geming-backend-dev.azurewebsites.net/api',
  // BACKEND_URL: 'http://localhost:1223/api',
  // BACKEND_URL: 'https://meli-backend.test/api',
  FRONTEND_URL: 'https://melitesis.azurewebsites.net',
  firebase: {
    apiKey: 'AIzaSyCMulr0myLI9GbMc_eQMr5yQTOy-wn1XBA',
    authDomain: 'shoplink-b0bca.firebaseapp.com',
    databaseURL: 'https://shoplink-b0bca.firebaseio.com',
    projectId: 'shoplink-b0bca',
    storageBucket: 'shoplink-b0bca.appspot.com',
    messagingSenderId: '805648232582',
    appId: '1:805648232582:web:82a79b574cb074e35ea107'
  }
};
